import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToolbarComponent {

    public selectedPage = 'rdm-home';

    public controlSelectedPage(selectedPage: string): void {

        this.selectedPage = selectedPage;
    }
}
